<template>
  <div class="sidebar">
    <div class="logo">
      <img src="@/assets/logo1.png" alt="番剧动漫" />
    </div>
    
    <!-- 用户信息或登录按钮 -->
    <div class="user-section">
      <div v-if="isLoggedIn" class="user-info" @click="navigateTo('/user/center')">
        <div class="avatar">
          <img :src="userInfo.avatar" :alt="userInfo.nickname" />
        </div>
        <div class="user-details">
          <div class="nickname">{{ userInfo.nickname }}</div>
          <div class="user-level">普通用户</div>
        </div>
      </div>
      <div v-else class="login-buttons">
        <router-link to="/login" class="btn-login">登录</router-link>
        <router-link to="/register" class="btn-register">注册</router-link>
      </div>
    </div>
    
    <ul class="nav-menu">
      <li :class="{ active: currentRoute === '/' }" @click="navigateTo('/')">
       
        <span>首页</span>
      </li>
      <li :class="{ active: currentRoute === '/category' }" @click="navigateTo('/category')">
        
        <span>分类</span>
      </li>
      <li class="divider"></li>
      <li v-if="isLoggedIn" :class="{ active: currentRoute === '/user/center' }" @click="navigateTo('/user/center')">
       
        <span>个人中心</span>
      </li>
      <li v-if="isLoggedIn" :class="{ active: currentRoute === '/vip' }" @click="navigateTo('/vip')">
     
        <span>开通VIP</span>
      </li>
      <li v-if="isLoggedIn" :class="{ active: currentRoute === '/user/recharge' }" @click="navigateTo('/user/recharge')">
      
        <span>充值金币</span>
      </li>
      <li class="divider"></li>
      <li :class="{ active: currentRoute === '/about' }" @click="navigateTo('/about')">
       
        <span>关于我们</span>
      </li>
     
     
    </ul>
    
    <!-- 如果已登录，显示退出按钮 -->
    <div v-if="isLoggedIn" class="logout-section">
      <button class="btn-logout" @click="handleLogout">退出登录</button>
    </div>
  </div>
</template>

<script>
import { computed, ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { isLoggedIn, getCurrentUser, logout } from '@/api/user';

export default {
  name: 'AppSidebar',
  setup() {
    const router = useRouter();
    const route = useRoute();
    
    const currentRoute = computed(() => route.path);
    const loggedIn = ref(false);
    const userInfo = ref(null);
    
    const checkLoginStatus = () => {
      loggedIn.value = isLoggedIn();
      if (loggedIn.value) {
        userInfo.value = getCurrentUser();
      }
    };
    
    const navigateTo = (path) => {
      router.push(path);
    };
    
    const handleLogout = () => {
      logout();
      checkLoginStatus();
      // 如果当前在需要登录的页面，则跳转到首页
      if (route.meta.requiresAuth) {
        router.push('/');
      } else {
        // 刷新当前页面
        router.go(0);
      }
    };
    
    onMounted(() => {
      checkLoginStatus();
    });
    
    return {
      currentRoute,
      navigateTo,
      isLoggedIn: loggedIn,
      userInfo,
      handleLogout
    };
  }
};
</script>

<style scoped>
.sidebar {
  width: 200px;
  background-color: #1f2937;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  padding: 20px 0;
  color: white;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.logo {
  text-align: center;
  margin-bottom: 20px;
  padding: 0 20px;
}

.logo img {
  max-width: 100%;
  height: auto;
}

.user-section {
  padding: 0 20px;
  margin-bottom: 20px;
}

.user-info {
  display: flex;
  align-items: center;
  padding: 10px 0;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 4px;
}

.user-info:hover {
  background-color: #374151;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-details {
  flex: 1;
}

.nickname {
  font-weight: bold;
  margin-bottom: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 110px;
}

.user-level {
  font-size: 12px;
  color: #9ca3af;
}

.login-buttons {
  display: flex;
  gap: 10px;
  padding: 10px 0;
}

.btn-login, .btn-register {
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 14px;
  text-decoration: none;
  text-align: center;
  flex: 1;
}

.btn-login {
  background-color: transparent;
  border: 1px solid #ff6b81;
  color: #ff6b81;
}

.btn-register {
  background-color: #ff6b81;
  color: white;
  border: 1px solid #ff6b81;
}

.nav-menu {
  list-style: none;
  padding: 0;
  flex: 1;
}

.nav-menu li {
  padding: 12px 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
}

.nav-menu li:hover {
  background-color: #374151;
}

.nav-menu li.active {
  background-color: #374151;
  border-left: 4px solid #ff6b81;
}

.nav-menu li.divider {
  height: 1px;
  background-color: #374151;
  margin: 10px 0;
  padding: 0;
}

.icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  background-color: #9ca3af;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}

.icon.home::before {
  content: "🏠";
}

.icon.category::before {
  content: "📚";
}

.icon.user::before {
  content: "👤";
}

.icon.vip::before {
  content: "👑";
}

.icon.coin::before {
  content: "💰";
}

.icon.about::before {
  content: "ℹ️";
}

.icon.contact::before {
  content: "📞";
}

.icon.agreement::before {
  content: "📝";
}

.icon.privacy::before {
  content: "🔒";
}

.logout-section {
  padding: 0 20px 20px;
}

.btn-logout {
  width: 100%;
  padding: 10px;
  background-color: transparent;
  border: 1px solid #ff6b81;
  color: #ff6b81;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-logout:hover {
  background-color: rgba(255, 107, 129, 0.1);
}
</style> 